import 'lazysizes';
import Iconify from '@iconify/iconify';
import Swiper, {Autoplay, Navigation} from 'swiper';
import Glightbox from 'glightbox';

window.GLightbox = Glightbox;
window.Swiper = Swiper;
Swiper.use([Autoplay, Navigation]);

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.nav__button')) {
        const button = document.querySelector('.nav__button');
        const nav = document.querySelector('.nav');

        button.addEventListener('click', (e) => {
            e.preventDefault();

            nav.classList.toggle('nav--open');
        })
    }

    if (document.querySelector('.nav__close')) {
        const button = document.querySelector('.nav__close');
        const nav = document.querySelector('.nav');

        button.addEventListener('click', (e) => {
            e.preventDefault();

            nav.classList.remove('nav--open');
        })
    }

    document.querySelectorAll('.menu-item-has-children > .nav__item-content > a').forEach(item => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
        });
    });
});